import MetaDataList from './MetaDataList';
import MetaDataCreate from './MetaDataCreate';
import MetaDataEdit from './MetaDataEdit';

const metadataResources = {
    list: MetaDataList,
    create: MetaDataCreate,
    edit: MetaDataEdit,
};

export default metadataResources;